import { ColumnDef } from "@tanstack/react-table";
import i18next from "i18next";

export const defaultTableColumns: ColumnDef<any, any>[] = [
  {
    accessorKey: "name",
    header: () => i18next.t("patientList_columns_name"),
    cell: (info) => info.renderValue(),
    size: 220,
    sortingFn: (rowA, rowB) => {
      const a = rowA.original.lastName ?? "";
      const b = rowB.original.lastName ?? "";
      return a.localeCompare(b);
    },
  },
  {
    accessorKey: "hospitalId",
    header: () => i18next.t("patientList_columns_hospitalId"),
    cell: (info) => info.renderValue(),
    size: 150,
    sortingFn: "text",
  },
  {
    accessorKey: "id",
    header: () => i18next.t("patientList_columns_pmpId"),
    cell: (info) => info.renderValue(),
    sortingFn: "basic",
  },
  {
    accessorKey: "alerts",
    header: () => i18next.t("patientList_columns_alerts"),
    cell: (info) => info.renderValue(),
    sortingFn: (rowA, rowB) => {
      return rowA.original.alertsCount - rowB.original.alertsCount;
    },
  },
  {
    accessorKey: "signUpDate",
    header: () => i18next.t("patientList_columns_signUpDate"),
    cell: (info) => info.renderValue(),
    size: 160,
    sortingFn: (rowA, rowB) => {
      return (
        rowB.original.signUpdateParsedDate - rowA.original.signUpdateParsedDate
      );
    },
  },
  {
    // accessorFn (not accessorKey) so getValue returns the timestamp — that's
    // what react-table's sortUndefined: "last" check inspects. With accessorKey
    // pointing at the formatted display string, sortUndefined never fires and
    // missing rows fall into the comparator as NaN, breaking the sort.
    id: "lastUsed",
    accessorFn: (row: { lastUsedDate?: number }) => row.lastUsedDate,
    header: () => i18next.t("patientList_columns_lastUsed"),
    cell: ({ row }) => (row.original as { lastUsed: string }).lastUsed,
    size: 170,
    sortingFn: (rowA, rowB) =>
      (rowB.getValue<number>("lastUsed") ?? 0) -
      (rowA.getValue<number>("lastUsed") ?? 0),
    sortUndefined: "last",
  },
  {
    accessorKey: "lastReviewedBy",
    header: () => i18next.t("patientList_columns_lastReviewedBy"),
    cell: (info) => info.renderValue(),
    size: 160,
    sortingFn: "text",
  },
  {
    accessorKey: "flag",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 30,
    enableSorting: false,
  },
  {
    accessorKey: "action",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 30,
    enableSorting: false,
  },
  {
    accessorKey: "alertsCount",
    size: 0,
  },
  {
    accessorKey: "surveyResultStatus",
    size: 0,
  },
  {
    accessorKey: "lastUsedDate",
    size: 0,
  },
  {
    accessorKey: "surveyReceivedDate",
    size: 0,
  },
  {
    accessorKey: "signUpdateParsedDate",
    size: 0,
  },
];

export const mobileAccordionListColumns = [
  {
    key: "Hospital ID",
    labelKey: "patientList_columns_hospitalId",
    value: "hospitalId",
  },
  { key: "pMp ID", labelKey: "patientList_columns_pmpId", value: "id" },
  {
    key: "Sign up date",
    labelKey: "patientList_columns_signUpDate",
    value: "signUpDate",
  },
  {
    key: "Hospital ID",
    labelKey: "patientList_columns_hospitalId",
    value: "hospitalId",
  },
  {
    key: "Last reviewed by",
    labelKey: "patientList_columns_lastReviewedBy",
    value: "lastReviewedBy",
  },
];
